/* eslint-disable no-underscore-dangle */
import { useEffect } from 'react';
import { useGetUserQuery } from 'src/common/slices';

export const useCustomerIOIdentify = () => {
  const { data: userData } = useGetUserQuery();

  useEffect(() => {
    if (!window._cio || !userData?.data?.user) return;

    window._cio.identify({
      id: userData.data.user._id,
    });
  }, [userData]);
};
